import { z } from 'zod';

export enum ChartType {
  VOLTAGE = 'Voltage',
  CURRENT = 'Current',
  SOC = 'SOC',
  TEMPERATURE = 'Temperature',
  CELL_VOLTAGE = 'CellVoltage',
}

export const ChartTypeSchema = z.nativeEnum(ChartType);
